<template>
    <div class="lms__superadmin_customer_edit">
        <div class="lms__superadmin_customer_edit_header">
            <view-actions
                ref="viewactions"
                :title="`Editing: ${customerName}`"
                :notify-title="'customer'"
                :notify-process="'Stop editing'"
                :trash-button-active="user.isSuperadmin()"
                :trash-notify-content="'Archiving this customer means users will lose access to the customer and features.'"
                :trash-notify-prevent-close="true"
                :cancel-button-text="'Back'"
                :cancel-notify-active="false"
                :submit-button-active="true"
                :submit-button-text="'Update'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'customer-update'"
                @emit-notify-remove-submit="customerRemove"
                @emit-cancel="customerStopEdit"
                @emit-submit="performSubmitValidate"
            />
        </div>
        <div class="lms__superadmin_customer_edit_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="[
                            { label: $t('lms.customer.labels.details'), name: 'lms-superadmin-customer-edit-details' },
                            { label: $t('lms.customer.labels.contacts'), name: 'lms-superadmin-customer-edit-contacts' },
                            { label: 'Options', name: 'lms-superadmin-customer-edit-options' },
                            { label: $t('lms.customer.labels.services'), name: 'lms-superadmin-customer-edit-services' },
                            { label: 'Email senders', name: 'lms-superadmin-customer-edit-email-senders' },
                            { label: $t('lms.customer.labels.workspaces'), name: 'lms-superadmin-customer-edit-workspaces' }
                        ]"></component-sidebar>
                    </div>
                    <div class="column custom--change p-t-b-0">
                        <section class="lms__superadmin_customer_edit_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import PopNotify from '@/components/default/shared/PopNotify'
import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'
import { User } from '@/User'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  name: 'lms-superadmin-customer-edit',
  components: { PopNotify, ComponentSidebar, ViewActions },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    customerId () {
      return this.$store.getters.getLmsSuperadminCustomerId
    },
    customerName () {
      return this.$store.getters.getLmsSuperadminCustomerName
    },
    //
    rootItemName () {
      return 'customer'
    },
    nameActionUpdate () {
      return 'lmsSuperadminCustomerUpdate'
    }
  },
  methods: {
    customerRemove () {
      this.allowRedirectBeforeRouteLeave()
      this.$store.dispatch('lmsSuperadminCustomerRemove', this.customerId).catch(() => {
        this.$refs.viewactions.$refs.popnotifyremove.closeNotify()
      })
    },
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-customer-update')
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-customer-update')
    },
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('customer-submit')
    },
    //
    customerStopEdit () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'lms-superadmin-customer-list' })
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomeraddedit.scss";
</style>
